{
  "caption": "Diez fases por diez fases. Las filas son la fase de la pregunta; las columnas, la fase de la opción elegida.",
  "phases": {
    "pluto": "Espíritu",
    "neptune": "Gestión",
    "uranus": "Liderazgo",
    "saturn": "Requerimientos",
    "sun": "Conceptualización",
    "moon": "Revisión",
    "mars": "Desarrollo",
    "mercury": "Diseño",
    "jupiter": "Operación",
    "venus": "Cierre"
  },
  "stats": {
    "total": "Σ",
    "totalLabel": "Total",
    "sd": "DE",
    "sdLabel": "Desviación estándar",
    "grid": "Cuadrícula completa",
    "gridSummary": "n {{n}} · Σ {{total}} · DE {{sd}}"
  }
}
